import { PopularArticle } from './cms-article.interface';

export interface PopularArticleItem {
  popularArticle: PopularArticle;
}
